import React, { FC, useEffect, useState } from 'react'
import { RouteComponentProps } from "@reach/router"
import _ from 'lodash'
import Isvg from 'react-inlinesvg'
// Components
import { Toolbar } from "components/subnav"
import AttributesTable from "components/asset-management/attributes/attributes-table"
import { Errors } from "components/asset-management/errors"
import { WithTip } from 'components/tooltip/with-tip'
// Data
import api_match from "data/interface/api"
import attributeService from "data/attributes"
import validationService from 'data/validate'
import { ContextRow } from './attributes-table'
import toggles from "feature-toggles"

//Styles
import { Attributes_s } from "components/asset-management/attributes/attribute-styles"
import { AddIcon } from "images/icons/tools"

const Attributes: FC<RouteComponentProps> = (props) => {
  const [data, setData] = useState<object[]>([])
  const [showSelected, setShowSelected] = useState<boolean>(false)
  const [selected, setSelected] = useState<ContextRow[]>([]);
  const tableId = "attributes-table"
  useEffect(() => {
    validationService.validate('attribute')
  },[])

  useEffect(() => {
    const attributeSubscription = attributeService.stream().subscribe(data => {
      api_match(
        data,
        init  => setData(init.value),
        ok    => {
          setData(ok.value)
        },
        err   => {
          setData(err.value) // backout any optimistic updates
        },
        fetch => {}
      )
    })

    attributeService.fetchAttributes()

    return function cleanup() {
      attributeSubscription.unsubscribe()
    }
  }, [])

  const Add = () => {
    return (
      <a onClick={() => attributeService.create()}>
        <Isvg src={AddIcon} width="20px" />
      </a>
    )
  }

  const [deleteFlag, setDeleteFlag] = useState(0)
  const Delete = () => {
    return (
      <WithTip position="bottom">
        <span>Delete Selected Rows</span>
        <a className={selected.length && !_.some(selected, 'systeminput')  ? '' : 'disabled'}
          onClick={() => {
            if (!selected.length || _.some(selected, 'systeminput')) return
            setDeleteFlag(deleteFlag+1)
        }}>
          <span className="p-menuitem-icon pi pi-fw pi-trash"></span>
        </a>
      </WithTip>
    )
  }

  const [pasteFlag, setPasteFlag] = useState(0)
  const Paste = () => {
    return (
      <WithTip position="bottom">
        <span>Paste to Selected Rows</span>
        <a className={selected.length && !_.some(selected, 'systeminput') ? '' : 'disabled'}
          onClick={() => {
            if (!selected.length || _.some(selected, 'systeminput')) return
            setPasteFlag(pasteFlag+1)
          }
        }>
          <span className="p-menuitem-icon pi pi-fw pi-clone"></span>
        </a>
      </WithTip>
    )
  }

  const ShowSelected = () => (
    <WithTip position="bottom">
      <span>Show {showSelected ? 'All' : 'Selected'} Rows</span>
      <a className={selected.length ? '' : 'disabled'}
        onClick={() => {
          if (!selected.length) return
          setShowSelected(!showSelected)
        }}>
        <span className={showSelected ? 'pi pi-eye-slash' : 'pi pi-eye'} style={{height: '18px', width: '18px'}}></span>
      </a>
    </WithTip>
  )

  useEffect(() => {
    setSelected(_.intersectionBy(data, selected, 'attributeid'))
  }, [data])

  useEffect(() => {
    if (showSelected && _.isEmpty(selected)) setShowSelected(false)
  }, [selected])

  const _data = showSelected ? selected : data

  return (
    <Attributes_s>
      <Toolbar>
        <Add />
        <Errors />
        {toggles.multiselect() && <>
          <Paste />
          <Delete />
          <ShowSelected />
        </>}
      </Toolbar>
      <AttributesTable tableId={tableId} data={_data} selectedState={[selected, setSelected]} flags={{deleteFlag, pasteFlag}} />
    </Attributes_s>
  )
}

export default Attributes
